import { render, staticRenderFns } from "./historyTrack.vue?vue&type=template&id=899d4958&scoped=true&"
import script from "./historyTrack.vue?vue&type=script&lang=js&"
export * from "./historyTrack.vue?vue&type=script&lang=js&"
import style0 from "./historyTrack.vue?vue&type=style&index=0&id=899d4958&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "899d4958",
  null
  
)

export default component.exports